import React from 'react';
import './FloatingIcon.scss';
import { SlEarphonesAlt } from "react-icons/sl";

const FloatingIcon = ({ onClick }) => {
  return (
    <div className="floating-icon-container" onClick={onClick}>
      <SlEarphonesAlt className="icon" />
    </div>
  );
};

export default FloatingIcon;
